import angular from 'angular';

import * as UnitHelper from './unit.helper';

let unitAuthenticationGoogleController = async function ($state, Unit, UnitDetail) {
  let $ctrl = this;
  $ctrl.uiState = 'LOADING';
  angular.extend($ctrl, {});
  let requestPackage = JSON.parse(sessionStorage.requestPackage);
  await UnitHelper.setToken($state.params);
  
  const runAction = () => {
    return {
      syncHoursGMB,
      approvalAttendanceHour,
      getLocationsGMB,
      approvedSpecialHours,
      removeSpecialHours,
      syncSpecialHours
    }[requestPackage.action](requestPackage.params)
  }

  const setResponse = itWorked => {
    requestPackage['response'] = {
      itWorked
    };
    sessionStorage.setItem('responsePackage', JSON.stringify(requestPackage));
    $state.go(requestPackage.redirectUrl, {id: requestPackage.params.id});
  }

  const approvalAttendanceHour = () => {
    Unit.approvalAttendanceHour(requestPackage.payload).then(async () => {
      await setResponse(true);
    }).catch(async () => {
      await setResponse(true);
    });
  }

  const syncHoursGMB = () => {
    UnitDetail.syncHoursGMB(requestPackage.payload).then(async () => {
      await setResponse(true);
    }).catch(async () => {
      await setResponse(false);
    });
  }

  const getLocationsGMB = () => {
    UnitDetail.getLocationsGMB().then(async data => {
      await setResponse(true);
      sessionStorage.setItem('locationsGMB', JSON.stringify(data));
    }).catch(async () => {
      await setResponse(false);
    });
  }

  const approvedSpecialHours = () => {
    UnitDetail.approveSpecialHours(requestPackage.payload).then(async () => {
      await setResponse(true);
    }).catch(async () => {
      await setResponse(false);
    });
  }

  const syncSpecialHours = () => {
    UnitDetail.syncSpecialHours(requestPackage.payload).then(async () => {
      await setResponse(true);
    }).catch(async () => {
      await setResponse(false);
    });
  }

  const removeSpecialHours = () => {
    UnitDetail.removeSpecialHours(requestPackage.payload).then(async () => {
      await setResponse(true);
    }).catch(async () => {
      await setResponse(false);
    });
  }

  runAction(requestPackage);
}

unitAuthenticationGoogleController.$inject = ['$state', 'Unit', 'UnitDetail'];

export default unitAuthenticationGoogleController;



// WEBPACK FOOTER //
// ./client/app/components/unit/unit-authentication-google.controller.js